module.exports = __webpack_public_path__ + "img/icon1.62fb7f4b.png";